/* istanbul ignore file */
import { useState } from 'react';
import {
  useServiceCatalogService,
  ASSIGN_SERVICE_CATALOG_OWNER,
  SERVICE_CATALOG_STATUSES,
} from 'domain/shared/serviceCatalog';
import { useParams } from 'react-router-dom';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { EmployeeInput, buildEmployeeAutoSuggestLabel } from 'domain/shared/employee';
import { snakeCase } from 'lodash';
import { FormFieldsData } from 'framework/form';
import { Box } from '@mui/material';

const AssignServiceCatalogOwnerButton = ({ statusSource }: { statusSource: string }) => {
  const { id } = useParams<Dictionary<string>>();
  const { assignServiceOwner, invalidateCache } = useServiceCatalogService();
  const { getValue } = useFieldHelper({ source: statusSource });
  const { setData = () => {} } = useShowContext();
  const status = getValue();

  const [owner, setOwner] = useState<string>('');

  const onOwnerCallback = (values: FormFieldsData) => {
    setOwner(values.owner);
  };

  if (status === SERVICE_CATALOG_STATUSES.ARCHIVED) {
    return null;
  }

  return (
    <ButtonWithConfirmation
      displayMessage="Do you really want to assign/reasign service owner?"
      modalChildren={
        <Box mt={2.5}>
          <EmployeeInput
            source="owner"
            label="New Owner"
            nameSource="employeeName"
            mapResults={(employee: any) => ({
              id: employee.alias,
              text: buildEmployeeAutoSuggestLabel(employee),
              office: employee.office ? snakeCase(employee.office).toUpperCase() : null,
            })}
            onChangeCallback={onOwnerCallback}
          />
        </Box>
      }
      submitMethod={() => assignServiceOwner(id!, owner)}
      afterSubmit={{
        successMessage: 'New service owner has been successfully assigned.',
        errorMessage: "Can't assign new owner.",
        execute: (data: any) => {
          invalidateCache();
          setData(data);
        },
      }}
      permissionToCheck={ASSIGN_SERVICE_CATALOG_OWNER}
      variant="outlined"
    >
      Assign service owner
    </ButtonWithConfirmation>
  );
};

export default AssignServiceCatalogOwnerButton;
